var windowWidth,lazyImages,lazyBackground,lazyIframe,lazyScripts,src,style,datasrc,urls,analytics,s,x,i,j,flag;
document.addEventListener("DOMContentLoaded", function() {
	windowWidth = screen.width;
	lazyImages = document.querySelectorAll('img.lazy');
  	lazydataImages = document.querySelectorAll('img[data-class=lazy]');
	lazyBackground = document.querySelectorAll('.lazybg');
	lazyIframe = document.querySelectorAll('iframe.lazy');
	lazyIvideo = document.querySelectorAll('video.lazy');
	lazyScripts = document.getElementsByTagName("script");
	i=0;
	j=0;
	flag=!0;
	window.addEventListener("scroll", function() {
		init();
	});
	window.addEventListener("mousemove", function() {
		init();
	});
	window.addEventListener("touchstart", function() {
		init();
	});
	setTimeout(function() {
		init();
	}, 6000);
/*
	if(document.querySelector('.bg_overlay_.lazyload') != null) {
		document.querySelectorAll('.bg_overlay_.lazyload').forEach(function(elem) {
			var elem = document.querySelector('.bg_overlay_.lazyload');
			var bg = elem.getAttribute('data-bgset');
			var res = bg.split(",");
			var res2 = res[8].split(" ");
			elem.parentElement.style.background = 'url('+res2[0]+')';
			elem.parentElement.style.backgroundPosition = "top";
			elem.parentElement.style.backgroundRepeat = "no-repeat";
			elem.parentElement.style.backgroundSize = "cover";
			elem.parentElement.style.visibility = "visible";
			elem.style.background = "none";
		});
	}
*/
});
function init() {
	if(flag != 0) {
		flag=0;
		lazyLoadImg();
		lazyLoadImg2();
		lazyLoadBackground();
		lazyLoadIframe();
		load_all_js();
	}
}
function lazyLoadImg() {
	lazyImages.forEach(function(elem) {
		if( windowWidth < 600 )
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
		else
			src = elem.dataset.src;

		if( src != null )
			elem.src = src;
	});
}
function lazyLoadImg2() {
	lazydataImages.forEach(function(elem) {
		if( windowWidth < 600 )
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
		else
			src = elem.dataset.src;

		if( src != null )
			elem.src = src;
	});
}
function lazyLoadBackground() {
	lazyBackground.forEach(function(elem) {
		if( windowWidth < 600 )
			style = (elem.dataset.mobstyle == undefined) ? elem.dataset.style : elem.dataset.mobstyle;
		else
			style = elem.dataset.style;

		if( style != null )
			elem.style = style;
	});
}
function lazyLoadIframe() {
	lazyIframe.forEach(function(elem) {
		datasrc = elem.dataset.src;
		if( datasrc != null )
			elem.src = datasrc;
	});

	lazyIvideo.forEach(function(elem) {
		datasrc = elem.dataset.src;
		if( datasrc != null )
			elem.src = datasrc;
	});
}
function lazyLoadScripts() {
	if (typeof lazyScripts[j] == 'undefined')
		return;

	if ( lazyScripts[j].getAttribute("type") == "lazyload2" ) {
		lazyScripts[j].setAttribute("type", "lazyloaded");
		if (typeof lazyScripts[j].dataset.src !== 'undefined') {
			s=document.createElement("script");
			s.type="text/javascript";
			s.async=!0;
			s.src=lazyScripts[j].dataset.src;
			x=document.getElementsByTagName("body")[0];
			x.appendChild(s);
			s.onload=function() {
				j++;
				lazyLoadScripts();
			};
		} else {
			s=document.createElement("script");
			s.type="text/javascript";
			s.async=!0;
			s.innerHTML=lazyScripts[j].innerHTML;
			x=document.getElementsByTagName("body")[0];
			x.appendChild(s);
			j++;
			lazyLoadScripts();
		}
	} else {
		j++;
		lazyLoadScripts();
	}
}
function lazyLoadCss(url) {
	s=document.createElement("link");
	s.rel="stylesheet";
	s.href=url;
	x=document.getElementsByTagName("head")[0];
	x.appendChild(s);
}
function lazyLoadJS(url) {
	s=document.createElement("script");
	s.type="text/javascript";
	s.async=!0;
	s.src=url;
	x=document.getElementsByTagName("body")[0];
	x.appendChild(s);
}
function asyncLoad() {
	urls = [];

	for (i = 0; i < urls.length; i++) {
		s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = urls[i];
		x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	}
setTimeout(function() {
		analyticscall();
	}, 200);

}
function load_all_js() {
//	asyncLoad();
  
	
  
	
	j=0;
	lazyLoadScripts();
  //lazyLoadCss("//tripese.com/cdn/shop/t/8/assets/wonify.scss.css?v=56737322954468821681759260338");
              lazyLoadCss("//tripese.com/cdn/shop/t/8/assets/owl.carousel.min.css?v=70516089817612781961602860477");
              lazyLoadCss("//tripese.com/cdn/shop/t/8/assets/owl.theme.default.min.css?v=96203393111014399201602860478");
}


if(document.querySelectorAll('.photo-zoom-link__initial.lazyload') != null){
document.querySelectorAll('.photo-zoom-link__initial.lazyload').forEach(function(elem) {
var str = elem.getAttribute('data-src');
//console.log(str);
var src = str.replace("{width}", "360");
	//	console.log(src);
    elem.src = src;
elem.style.opacity = '1';
	});
}
if(document.querySelectorAll('.product__thumb img.lazyload') != null){
document.querySelectorAll('.product__thumb img.lazyload').forEach(function(elem) {
var str = elem.getAttribute('data-src');
//console.log(str);
var src = str.replace("{width}", "180");
	//	console.log(src);
    elem.src = src;
elem.style.opacity = '1';
	});
}
/*if(document.querySelectorAll('img.lazyload') != null){
document.querySelectorAll('img.lazyload').forEach(function(elem) {
var str = elem.getAttribute('data-src');
//console.log(str);
var src = str.replace("{width}", "180");
	//	console.log(src);
    elem.src = src;
elem.style.opacity = '1';
	});
}*/
if(document.querySelector('.hero__image.lazyload') != null){
  document.querySelectorAll('.hero__image.lazyload').forEach(function(elem) {
  	var bg = elem.getAttribute('data-bgset');
	var res = bg.split(",");
		
	var res2 = res[6].split(" ");
		
	elem.style.background = 'url('+res2[2]+')';
	elem.style.backgroundPosition = "center center";
	elem.style.backgroundRepeat = "no-repeat";
    elem.style.backgroundSize = "Cover";
	
  })
}
 
function analyticscall(){
analytics = document.getElementsByClassName("analytics");
  if(analytics != null){
	s=document.createElement("script");
	s.type="text/javascript";
	s.innerHTML=analytics[0].innerHTML;
	x=document.getElementsByTagName("body")[0];
	x.appendChild(s);
  }
}